import ReactDOM from 'react-dom';
import { Messages } from './results';
import { Api } from '@fnv-core/http';
import { IApiOptions } from '@fnv-core/http/interfaces';
import { IBulletinMessage, IBulletinMessageInput } from './interfaces';

export class BulletinBoardService {

  private static baseApiUrl = '/api';
  private static defaultApiOptions: IApiOptions = { cache: true };

  public static async getMessages(element?: HTMLElement) {

    element ??= document.getElementsByClassName("bulletinboard-enabled")[0] as HTMLElement;
    const domContainer = document.getElementById('bulletinmessages_' + element.dataset.widgetid);

    if (domContainer) {

      ReactDOM.render(null, domContainer);

      var result = await BulletinBoardService.getMessagesFromApi();
      if (result.length > 0) {
        ReactDOM.render(Messages(result, element.dataset.widgetid), domContainer);
      }

    }
  }

  // returns messages
  public static async getMessagesFromApi() {

    let url = `${this.baseApiUrl}/bulletinboard/getmessages`;

    try {
      const result = await Api.get<IBulletinMessage[]>(
        url,
        this.defaultApiOptions
      );

      return result;
    } catch (ex) {
      console.error(ex);
      return [];
    }
  }

  public static async PostMessage(message: IBulletinMessageInput) {

    const element = document.getElementsByClassName("bulletinboard-enabled")[0] as HTMLElement;
    const txtArea = element.querySelectorAll("textarea")[0];

    let success = element.getElementsByClassName("alert-success")[0] as HTMLElement;
    let warning = element.getElementsByClassName("alert-warning")[0] as HTMLElement;

    success.classList.add('d-none');
    warning.classList.add('d-none');

    try {

      let url = `${BulletinBoardService.baseApiUrl}/bulletinboard/postmessage`;
      let result = await Api.post<string>(url, message, BulletinBoardService.defaultApiOptions);
      BulletinBoardService.EmptyEntries(element);
      txtArea.value = "";
      BulletinBoardService.ClearCounters();
      success.classList.remove('d-none');
    }
    catch {
      warning.classList.remove('d-none');
    }

  }

  public static async PostReaction(event) {

    const sender = event.target as HTMLButtonElement;
    const element = sender.closest('.widget-bulletin-board__reaction');
    const txtArea = element.querySelectorAll("textarea")[0];
    const success = element.getElementsByClassName("alert-success")[0] as HTMLElement;
    const warning = element.getElementsByClassName("alert-warning")[0] as HTMLElement;

    success.classList.add('d-none');
    warning.classList.add('d-none');

    const message = {
      parentMessageId: sender.dataset.parentid,
      message: (document.getElementById("Reaction-" + sender.dataset.parentid) as HTMLInputElement).value,
    };

    try {

      let url = `${BulletinBoardService.baseApiUrl}/bulletinboard/postreaction`;
      let result = await Api.post<string>(url, message, BulletinBoardService.defaultApiOptions);
      txtArea.value = "";
      BulletinBoardService.ClearCounters();
      success.classList.remove('d-none');
    } catch (ex) {
      warning.classList.remove('d-none');
    }

  }

  public static CharCounter(event) {

    const msgArea = event.target as HTMLTextAreaElement;

    const element = msgArea.closest('.col');
    const current = element.getElementsByClassName("current")[0] as HTMLElement;

    let characterCount = msgArea.value.length;
    current.innerHTML = characterCount.toString();
  }

  private static ClearCounters()
  {
    const elements = document.getElementsByClassName("current");
    for (var i = 0; i < elements.length; i++) {
      elements[i].innerHTML = "0";
    }
  }

  private static EmptyEntries(element: HTMLElement) {
    const elements = element.getElementsByTagName("input");
    for (var ii = 0; ii < elements.length; ii++) {
      if (elements[ii].type == "text") {
        elements[ii].value = "";
      }
    }
  }

  public static SetSelectedMessage(event){
    var sender = event.target as HTMLElement;
    localStorage.setItem('selectedMessage', sender.id); 
  }

}